import uuid from "react-uuid";

import store from "../store";
import { setSingleTemplate } from "../store/singleTemplateReducer";

import { fileNameWithDate } from './functions'

export const generateTemplatesToJSON = (templates = []) => {
  const generateValue = ({ name, type, value }) => {
    let rawValue;
    switch (type.value) {
      case "number":
        rawValue = Number(value.value);
        break;
      case "object":
        rawValue = value.value.map((item) => generateValue(item));
        break;
      case "boolean":
        rawValue = Boolean(value.value);
        break;
      default:
        rawValue = `${value.value}`;
    }

    return {
      [name.value]: rawValue,
    };
  };

  const templateList = templates.map(({ name, fields = [],description={value:''} }) => ({
    [name.value]: {...Object.assign(
      {},
      ...fields.map((item) => generateValue(item))
    ), description:description || null},
  }));

  return templateList.map((template) => {
    const obj = {};

    const [[key, value]] = Object.entries(template);
    obj[key] = value;

    const result = JSON.stringify(obj)
      .replace(/\[/g, "{")
      .replace(/\]/g, "}")
      .replace(/\},\{/g, ",")
      .replace(/\{\{/g, "{")
      .replace(/\}\}/g, "}");

    return JSON.parse(`${result}}`);
  });
};

export const generateTemplatesFromJSON = (templates = []) => {
  return templates.flatMap((item) =>
    Object.entries(item).map(([name, fields = {}]) =>{
      const {description={value:''}, ...restFields} = fields
      return({
      name: {
        value: name,
        error: false,
      },
      description,
      fields: Object.entries(restFields).map(([name, value]) => {
        const itemGenerator = (name, value) => {
          return {
            id: uuid(),
            name: {
              value: name,
              error: false,
            },
            type: {
              error: false,
              value: typeof value,
            },
            value: {
              error: false,
              value:
                typeof value === "object"
                  ? Object.entries(value).map(([name, value]) =>
                      itemGenerator(name, value)
                    )
                  : value,
            },
          };
        };

        return itemGenerator(name, value);
      }),
    })})
  );
};

export const filterTemplateName = (name = "") =>
  name.trim().replace(/\s/g, "_").replace(/\W/g, "");

export const exportSingleTemplate = async (index, templates) => {
  const data = generateTemplatesToJSON([templates[index]]);
  const jsonTemplate = JSON.stringify(data, null, 2);

  try {
    const dataStr =
      "data:text/json;charset=utf-8," + encodeURIComponent(jsonTemplate);
    const link = document.createElement("a");
    link.setAttribute("href", dataStr);
    link.setAttribute(
      "download",
      `template ${fileNameWithDate(templates[index].name.value)}.json`
    );
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (e) {
    console.error(e);
  }
};

export const importSingleTemplate = (e) => {
  e.stopPropagation();
  e.preventDefault();

  const file = e.target.files[0];
  const reader = new FileReader();

  reader.onload = function (e) {
    // import firs one template from list
    store.dispatch(setSingleTemplate([JSON.parse(e.target.result)[0]]));
    e.target.value = '';
  };

  reader.readAsText(file);
};
